// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"55ed16ea","122":"de0e1183","256":"7c90768b","398":"9d6ba5ff","420":"825ce03c","662":"da1be227","700":"c441ea3f","844":"8848e90d","902":"3541d1af"}[chunkId] + ".chunk.js";
};